/**
 * [getHighlightsAndMarkers description]
 * @return {Object} data     [highlight & marker key/value]
 */
async function getHighlightsAndMarkers() {
  try {
    console.time('learnkit#getHighlightsAndMarkers')
    const res = await window.vsViewer.getHighlights();
    const { data } = res;
    console.timeEnd('learnkit#getHighlightsAndMarkers')
    return data;
  } catch (err) {
    console.error(err);
  }
}

/**
 * [createHighlight description]
 * @param  {String} options.markerId  [VS globalId of marker]
 * @return {Object}                   [highlight data]
 */
async function createHighlight({ markerId, noteText }) {
  try {
    console.time('learnkit#createHighlight')
    const options = {
      markerId,
      noteText
    };
    const res = await window.vsViewer.highlightCurrentSelection(options);
    const { data } = res;
    console.timeEnd('learnkit#createHighlight')
    return {
      highlight: data && data.highlight ? data.highlight : null,
    };
  } catch (err) {
    window.logger.error('CREATE_HIGHLIGHT--failed', { refId: window._ref_id, err });
    console.error(err);
  }
}

/**
 * [updateHighlight description]
 * @param  {String} highlightId      [VS syncId]
 * @param  {String} options.markerId [VS globalId]
 * @param  {String} options.noteText [User input]
 * @return {Object}                  [highlight data]
 */
async function updateHighlight(highlightId, markerId, noteText) {
  try {
    console.time('learnkit#updateHighlight')
    const options = {
      markerId,
      noteText
    };
    const res = await window.vsViewer.updateHighlight(highlightId, options);
    const { data } = res ?? {};
    console.timeEnd('learnkit#updateHighlight')
    return {
      highlight: data && data.highlight ? data.highlight : null,
    };
  } catch (err) {
    window.logger.error('UPDATE_HIGHLIGHT--failed', { refId: window._ref_id, err });
    console.error(err);
  }
}

/**
 * [deleteHighlight description]
 * @param  {String} highlightId   [VS syncId]
 * @return {Object}               [Code & message]
 */
async function deleteHighlight(highlightId) {
  try {
    console.time('learnkit#deleteHighlight')
    const res = await window.vsViewer.deleteHighlight(highlightId);
    console.timeEnd('learnkit#deleteHighlight')
    return res;
  } catch (err) {
    window.logger.error('DELETE_HIGHLIGHT--failed', { refId: window._ref_id, err });
    console.error(err);
  }
}

/**
 * [getMarkers description]
 * @return {Object} [markers]
 */
async function getMarkers() {
  try {
    console.time('learnkit#getMarkers')
    const res = await window.Crane.getMarkers();
    const { data } = res;
    console.timeEnd('learnkit#getMarkers')
    return { markers: data.markers };
  } catch (err) {
    window.logger.error('GET_MARKERS--failed', { refId: window._ref_id, err });
    console.error(err);
  }
}

/**
 * [getPageBreaks description]
 * @return {Object} [pagelist]
 */
async function getPageBreaks() {
  try {
    console.time('learnkit#getPageBreaks')
    const res = await window.vsViewer.getPageBreaks();
    const { data } = res;
    console.timeEnd('learnkit#getPageBreaks')
    return { pageBreaks: data.pagelist };
  } catch (err) {
    console.error(err);
  }
}

/**
 * [createMarker description]
 * @param  {String} options.color       [vstColor]
 * @param  {String} options.friendsOnly [sharing option]
 * @param  {String} options.label       [marker label]
 * @param  {String} options.shared      [sharing option]
 * @return {String}                     [code, data, message]
 */
async function createMarker({ color, friendsOnly, label, shared }) {
  try {
    console.time('learnkit#createMarker')
    const marker = {
      color,
      friendsOnly,
      label,
      shared
    };
    const res = await window.Crane.createMarker(marker);
    const { data } = res;
    console.timeEnd('learnkit#createMarker')
    return { data };
  } catch (err) {
    window.logger.error('CREATE_MARKER--failed', { refId: window._ref_id, err });
    console.error(err);
  }
}

/**
 * [deleteMarker description]
 * @param  {String} markerId [VS globalId that identifies specific marker reference]
 * @return {Object}          [code, markerId, message]
 */
async function deleteMarker(markerId) {
  try {
    console.time('learnkit#deleteMarker')
    console.timeEnd('learnkit#deleteMarker')
    return { markerId };
  } catch (err) {
    window.logger.error('DELETE_MARKER--failed', { refId: window._ref_id, err });
    console.error(err);
  }
}

/**
 * [getBookmarks description]
 * @return {Array}           [Array of objects]
 */
async function getBookmarks() {
  try {
    console.time('learnkit#getBookmarks')
    const res = await window.vsViewer.getBookmarks();
    const { data } = res;
    console.timeEnd('learnkit#getBookmarks')
    return { bookmarks: data.bookmarks };
  } catch (err) {
    console.error(err);
  }
}

/**
 * [getTOC description]
 * @return {Array}           [Array of objects]
 */
async function getTOC() {
  try {
    console.time('learnkit#getTOC')
    const res = await window.vsViewer.getTOC();
    const { data } = res;
    console.timeEnd('learnkit#getTOC')
    return { toc: data.toc };
  } catch (err) {
    console.error(err);
  }
}


/**
 * [createBookmark description]
 * @param  {[type]} options.currentCfi  [CFI from scroll event]
 * @param  {[type]} options.currentPage [Page from page break]
 * @return {[type]}                     [vs bookmark]
 */
async function createBookmark() {
  try {
    console.time('learnkit#createBookmark')
    const res = await window.vsViewer.setBookmark();
    const { data } = res;
    console.timeEnd('learnkit#createBookmark')
    return { bookmark: data.bookmark };
  } catch (err) {
    console.error(err);
  }
}

/**
 * [deleteBookmark description]
 * @param  {String} guid     [VS id that identifies unique bookmarks]
 * @return {Object}          [code, data, message]
 */
async function deleteBookmark(guid) {
  try {
    console.time('learnkit#deleteBookmark')
    const res = await window.vsViewer.deleteBookmark(guid);
    const { data } = res;
    console.timeEnd('learnkit#deleteBookmark')
    return { data };
  } catch (err) {
    console.error(err);
  }
}

/**
 * [goToCFI description]
 * @param  {String} cfi      [ebook CFI]
 * @return {Object} data     [code, data, message]
 */
async function goToCFI(cfi) {
  try {
    console.time('learnkit#goToCFI')
    const res = await window.vsViewer.goToCFI(cfi);
    const { data } = res;
    console.timeEnd('learnkit#goToCFI')
    return { data };
  } catch (err) {
    console.error(err);
  }
}

async function goToPageNumber(label) {
  try {
    console.time('learnkit#goToPageNumber')
    const res = await window.vsViewer.goToPage(label);
    console.timeEnd('learnkit#goToPageNumber')
    return res;
  } catch (err) {
    console.error(err);
  }
}

/**
 * [goToPreviousPage description]
 * @return {[type]} [description]
 */
async function goToPreviousPage() {
  try {
    console.time('learnkit#goToPreviousPage')
    const res = await window.vsViewer.goToPreviousPage();
    console.timeEnd('learnkit#goToPreviousPage')
    return res;
  } catch (err) {
    console.error(err);
  }
}

/**
 * [goToNextPage description]
 * @return {[type]} [description]
 */
async function goToNextPage() {
  try {
    console.time('learnkit#goToNextPage')
    const res = await window.vsViewer.goToNextPage();
    console.timeEnd('learnkit#goToNextPage')
    return res;
  } catch (err) {
    console.error(err);
  }
}

/**
 * [getNextPageInfo description]
 * @return {[type]} [description]
 */
async function getNextPageInfo() {
  try {
    console.time('learnkit#getNextPageInfo')
    const res = await window.vsViewer.getNextPage();
    console.timeEnd('learnkit#getNextPageInfo')
    const { data } = res;
    return { data };
  } catch (err) {
    console.error(err);
  }
}

/**
 * [getPreviousPageInfo description]
 * @return {[type]} [description]
 */
async function getPreviousPageInfo() {
  try {
    console.time('learnkit#getPreviousPageInfo')
    const res = await window.vsViewer.getPreviousPage();
    console.timeEnd('learnkit#getPreviousPageInfo')
    const { data } = res;
    return { data };
  } catch (err) {
    console.error(err);
  }
}

export {
  createBookmark,
  createHighlight,
  createMarker,
  deleteBookmark,
  deleteHighlight,
  deleteMarker,
  getBookmarks,
  getTOC,
  getHighlightsAndMarkers,
  getMarkers,
  getNextPageInfo,
  getPreviousPageInfo,
  goToCFI,
  goToNextPage,
  goToPreviousPage,
  goToPageNumber,
  getPageBreaks,
  updateHighlight
};
